module.exports = __webpack_public_path__ + "img/i1.3b0b369e.jpg";